const aesjs = require('aes-js');

module.exports = function encryptor (keyString,input,pref,s) {
    
    const key = keyString.trim();
    const value = input.trim();
    const keyBuffer = aesjs.utils.utf8.toBytes(key);
    const inputBuffer = aesjs.padding.pkcs7.pad(aesjs.utils.utf8.toBytes(value));
    
    const escEcb = new aesjs.ModeOfOperation.ecb(keyBuffer);
    const encryptedBytes = escEcb.encrypt(inputBuffer);
    
    const encryptedData = Buffer.from(encryptedBytes).toString('base64');
    if(pref,s){
        const t_pref = pref.trim();
        const t_s = s.trim();
        return `${t_pref}${t_s}${encryptedData}`
    }
    return encryptedData;
    };